import {
	CREATE_CASE_REQUEST,
	CREATE_CASE_REQUEST_FAILED,
	CREATE_CASE_REQUEST_FAILED_CLEAR,
	CREATE_CASE_REQUEST_SUCCESS,
	EXTRACT_FILE_REQUEST,
	EXTRACT_FILE_REQUEST_CLEAR_ALL,
	EXTRACT_FILE_REQUEST_CLEAR,
	EXTRACT_FILE_REQUEST_FAILED,
	EXTRACT_FILE_REQUEST_SUCCESS,
	GET_CASE_LIST_REQUEST,
	GET_CASE_LIST_REQUEST_FAILED,
	GET_CASE_LIST_REQUEST_FAILED_CLEAR,
	GET_CASE_LIST_REQUEST_SUCCESS,
	UPLOAD_FILE_REQUEST,
	UPLOAD_FILE_REQUEST_CLEAR,
	UPLOAD_FILE_REQUEST_CLEAR_ALL,
	UPLOAD_FILE_REQUEST_FAILED,
	UPLOAD_FILE_REQUEST_SUCCESS,
	KB_MAKING_TRIGGER_REQUEST,
	KB_MAKING_TRIGGER_REQUEST_CLEAR,
	KB_MAKING_TRIGGER_REQUEST_CLEAR_ALL,
	KB_MAKING_TRIGGER_REQUEST_FAILED,
	KB_MAKING_TRIGGER_REQUEST_SUCCESS,
	PII_EXTRACT_TRIGGER_REQUEST,
	PII_EXTRACT_TRIGGER_REQUEST_CLEAR,
	PII_EXTRACT_TRIGGER_REQUEST_CLEAR_ALL,
	PII_EXTRACT_TRIGGER_REQUEST_FAILED,
	PII_EXTRACT_TRIGGER_REQUEST_SUCCESS,
	REVERT_PII_EXTRACT_REQUEST,
	REVERT_PII_EXTRACT_REQUEST_CLEAR,
	REVERT_PII_EXTRACT_REQUEST_CLEAR_ALL,
	REVERT_PII_EXTRACT_REQUEST_FAILED,
	REVERT_PII_EXTRACT_REQUEST_SUCCESS,
	REVERT_TEXT_EXTRACT_REQUEST,
	REVERT_TEXT_EXTRACT_REQUEST_CLEAR,
	REVERT_TEXT_EXTRACT_REQUEST_CLEAR_ALL,
	REVERT_TEXT_EXTRACT_REQUEST_FAILED,
	REVERT_TEXT_EXTRACT_REQUEST_SUCCESS,
	GET_CASE_DETAILS_REQUEST,
	GET_CASE_DETAILS_REQUEST_FAILED,
	GET_CASE_DETAILS_REQUEST_FAILED_CLEAR,
	GET_CASE_DETAILS_REQUEST_SUCCESS,
	GET_EXTRACT_JOB_DETAILS_REQUEST,
	GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS,
	GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED,
	GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR,
	GET_UPLOAD_JOB_DETAILS_REQUEST,
	GET_UPLOAD_JOB_DETAILS_REQUEST_SUCCESS,
	GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED,
	GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED_CLEAR,
	GET_KB_MAKING_DETAILS_REQUEST,
	GET_KB_MAKING_DETAILS_REQUEST_SUCCESS,
	GET_KB_MAKING_DETAILS_REQUEST_FAILED,
	GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR,
	GET_PII_DETAILS_REQUEST,
	GET_PII_DETAILS_REQUEST_SUCCESS,
	GET_PII_DETAILS_REQUEST_FAILED,
	GET_PII_DETAILS_REQUEST_FAILED_CLEAR,
	GET_UPLOAD_FILE_SUMMARY_REQUEST,
	GET_UPLOAD_FILE_SUMMARY_REQUEST_SUCCESS,
	GET_UPLOAD_FILE_SUMMARY_REQUEST_FAILED,
	GET_UPLOAD_FILE_SUMMARY_REQUEST_CLEAR,
	DELETE_CASE_REQUEST,
	DELETE_CASE_REQUEST_SUCCESS,
	DELETE_CASE_REQUEST_FAILED,
	DELETE_CASE_REQUEST_CLEAR,
	CHANGE_CASE_MODE_REQUEST,
	CHANGE_CASE_MODE_REQUEST_SUCCESS,
	CHANGE_CASE_MODE_REQUEST_FAILED,
	CHANGE_CASE_MODE_REQUEST_CLEAR,
	GET_BIFROST_JOB_DETAILS_REQUEST,
	GET_BIFROST_JOB_DETAILS_REQUEST_SUCCESS,
	GET_BIFROST_JOB_DETAILS_REQUEST_RESET,
	GET_BIFROST_JOB_DETAILS_REQUEST_FAILED,
	POST_BIFROST_JOB_REQUEST,
	POST_BIFROST_JOB_REQUEST_SUCCESS,
	POST_BIFROST_JOB_REQUEST_FAILED,
	POST_BIFROST_JOB_REQUEST_RESET,
} from "../types"

//create
export const createCaseRequest = (data) => ({
	type: CREATE_CASE_REQUEST,
	payload: data,
})

export const createCaseRequestSuccess = (data) => ({
	type: CREATE_CASE_REQUEST_SUCCESS,
	payload: data,
})

export const createCaseRequestFailed = (data) => ({
	type: CREATE_CASE_REQUEST_FAILED,
	payload: data,
})

export const createCaseRequestFailedClear = (data) => ({
	type: CREATE_CASE_REQUEST_FAILED_CLEAR,
})

//get list
export const getCaseListRequest = (data) => ({
	type: GET_CASE_LIST_REQUEST,
	payload: data,
})

export const getCaseListRequestSuccess = (data) => ({
	type: GET_CASE_LIST_REQUEST_SUCCESS,
	payload: data,
})

export const getCaseListRequestFailed = (data) => ({
	type: GET_CASE_LIST_REQUEST_FAILED,
	payload: data,
})

export const getCaseListRequestFailedClear = (data) => ({
	type: GET_CASE_LIST_REQUEST_FAILED_CLEAR,
})

//upload files
export const uploadFileRequest = (data) => ({
	type: UPLOAD_FILE_REQUEST,
	payload: data,
})

export const uploadFileRequestSuccess = (data) => ({
	type: UPLOAD_FILE_REQUEST_SUCCESS,
	payload: data,
})

export const uploadFileRequestFailed = (data) => ({
	type: UPLOAD_FILE_REQUEST_FAILED,
	payload: data,
})

export const uploadFileRequestClear = (data) => ({
	type: UPLOAD_FILE_REQUEST_CLEAR,
	payload: data,
})

export const uploadFileRequestClearAll = () => ({
	type: UPLOAD_FILE_REQUEST_CLEAR_ALL,
})

//extract files
export const extractFileRequest = (data) => ({
	type: EXTRACT_FILE_REQUEST,
	payload: data,
})

export const extractFileRequestSuccess = (data) => ({
	type: EXTRACT_FILE_REQUEST_SUCCESS,
	payload: data,
})

export const extractFileRequestFailed = (data) => ({
	type: EXTRACT_FILE_REQUEST_FAILED,
	payload: data,
})

export const extractFileRequestClear = (data) => ({
	type: EXTRACT_FILE_REQUEST_CLEAR,
	payload: data,
})

export const extractFileRequestClearAll = () => ({
	type: EXTRACT_FILE_REQUEST_CLEAR_ALL,
})

//Kb making trigger
export const kbMakingTriggerRequest = (data) => ({
	type: KB_MAKING_TRIGGER_REQUEST,
	payload: data,
})

export const kbMakingTriggerRequestSuccess = (data) => ({
	type: KB_MAKING_TRIGGER_REQUEST_SUCCESS,
	payload: data,
})

export const kbMakingTriggerRequestFailed = (data) => ({
	type: KB_MAKING_TRIGGER_REQUEST_FAILED,
	payload: data,
})

export const kbMakingTriggerRequestClear = (data) => ({
	type: KB_MAKING_TRIGGER_REQUEST_CLEAR,
	payload: data,
})

export const kbMakingTriggerRequestClearAll = () => ({
	type: KB_MAKING_TRIGGER_REQUEST_CLEAR_ALL,
})

//Pii Extract trigger
export const PiiExtractTriggerRequest = (data) => ({
	type: PII_EXTRACT_TRIGGER_REQUEST,
	payload: data,
})

export const PiiExtractTriggerRequestSuccess = (data) => ({
	type: PII_EXTRACT_TRIGGER_REQUEST_SUCCESS,
	payload: data,
})

export const PiiExtractTriggerRequestFailed = (data) => ({
	type: PII_EXTRACT_TRIGGER_REQUEST_FAILED,
	payload: data,
})

export const PiiExtractTriggerRequestClear = (data) => ({
	type: PII_EXTRACT_TRIGGER_REQUEST_CLEAR,
	payload: data,
})

export const PiiExtractTriggerRequestClearAll = () => ({
	type: PII_EXTRACT_TRIGGER_REQUEST_CLEAR_ALL,
})

//Revert Pii Extract
export const RevertPiiExtractRequest = (data) => ({
	type: REVERT_PII_EXTRACT_REQUEST,
	payload: data,
})

export const RevertPiiExtractRequestSuccess = (data) => ({
	type: REVERT_PII_EXTRACT_REQUEST_SUCCESS,
	payload: data,
})

export const RevertPiiExtractRequestFailed = (data) => ({
	type: REVERT_PII_EXTRACT_REQUEST_FAILED,
	payload: data,
})

export const RevertPiiExtractRequestClear = (data) => ({
	type: REVERT_PII_EXTRACT_REQUEST_CLEAR,
	payload: data,
})

export const RevertPiiExtractRequestClearAll = () => ({
	type: REVERT_PII_EXTRACT_REQUEST_CLEAR_ALL,
})

//Revert Text Extract
export const RevertTextExtractRequest = (data) => ({
	type: REVERT_TEXT_EXTRACT_REQUEST,
	payload: data,
})

export const RevertTextExtractRequestSuccess = (data) => ({
	type: REVERT_TEXT_EXTRACT_REQUEST_SUCCESS,
	payload: data,
})

export const RevertTextExtractRequestFailed = (data) => ({
	type: REVERT_TEXT_EXTRACT_REQUEST_FAILED,
	payload: data,
})

export const RevertTextExtractRequestClear = (data) => ({
	type: REVERT_TEXT_EXTRACT_REQUEST_CLEAR,
	payload: data,
})

export const RevertTextExtractRequestClearAll = () => ({
	type: REVERT_TEXT_EXTRACT_REQUEST_CLEAR_ALL,
})

//get case details
export const getCaseDetailsRequest = (data) => ({
	type: GET_CASE_DETAILS_REQUEST,
	payload: data,
})

export const getCaseDetailsRequestSuccess = (data) => ({
	type: GET_CASE_DETAILS_REQUEST_SUCCESS,
	payload: data,
})

export const getCaseDetailsRequestFailed = (data) => ({
	type: GET_CASE_DETAILS_REQUEST_FAILED,
	payload: data,
})

export const getCaseDetailsRequestFailedClear = () => ({
	type: GET_CASE_DETAILS_REQUEST_FAILED_CLEAR,
})

//get extract details
export const getExtractJobDetailsRequest = (data) => ({
	type: GET_EXTRACT_JOB_DETAILS_REQUEST,
	payload: data,
})

export const getExtractJobDetailsRequestSuccess = (data) => ({
	type: GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS,
	payload: data,
})

export const getExtractJobDetailsRequestFailed = (data) => ({
	type: GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED,
	payload: data,
})

export const getExtractJobDetailsRequestFailedClear = () => ({
	type: GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR,
})

//get upload details
export const getUploadJobDetailsRequest = (data) => ({
	type: GET_UPLOAD_JOB_DETAILS_REQUEST,
	payload: data,
})

export const getUploadJobDetailsRequestSuccess = (data) => ({
	type: GET_UPLOAD_JOB_DETAILS_REQUEST_SUCCESS,
	payload: data,
})

export const getUploadJobDetailsRequestFailed = (data) => ({
	type: GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED,
	payload: data,
})

export const getUploadJobDetailsRequestFailedClear = () => ({
	type: GET_UPLOAD_JOB_DETAILS_REQUEST_FAILED_CLEAR,
})

//get Kb Making details
export const getKbMakingDetailsRequest = (data) => ({
	type: GET_KB_MAKING_DETAILS_REQUEST,
	payload: data,
})

export const getKbMakingDetailsRequestSuccess = (data) => ({
	type: GET_KB_MAKING_DETAILS_REQUEST_SUCCESS,
	payload: data,
})

export const getKbMakingDetailsRequestFailed = (data) => ({
	type: GET_KB_MAKING_DETAILS_REQUEST_FAILED,
	payload: data,
})

export const getKbMakingDetailsRequestFailedClear = () => ({
	type: GET_KB_MAKING_DETAILS_REQUEST_FAILED_CLEAR,
})

//get pii extract details
export const getPiiDetailsRequest = (data) => ({
	type: GET_PII_DETAILS_REQUEST,
	payload: data,
})

export const getPiiDetailsRequestSuccess = (data) => ({
	type: GET_PII_DETAILS_REQUEST_SUCCESS,
	payload: data,
})

export const getPiiDetailsRequestFailed = (data) => ({
	type: GET_PII_DETAILS_REQUEST_FAILED,
	payload: data,
})

export const getPiiDetailsRequestFailedClear = () => ({
	type: GET_PII_DETAILS_REQUEST_FAILED_CLEAR,
})

//Get Upload File Summary
export const getUploadFileSummaryRequest = (data) => ({
	type: GET_UPLOAD_FILE_SUMMARY_REQUEST,
	payload: data,
})

export const getUploadFileSummarySuccess = (data) => ({
	type: GET_UPLOAD_FILE_SUMMARY_REQUEST_SUCCESS,
	payload: data,
})

export const getUploadFileSummaryFailed = (data) => ({
	type: GET_UPLOAD_FILE_SUMMARY_REQUEST_FAILED,
	payload: data,
})

export const getUploadFileSummaryClear = () => ({
	type: GET_UPLOAD_FILE_SUMMARY_REQUEST_CLEAR,
})

//Delete Case
export const deleteCaseRequest = (data) => ({
	type: DELETE_CASE_REQUEST,
	payload: data,
})

export const deleteCaseRequestSuccess = (data) => ({
	type: DELETE_CASE_REQUEST_SUCCESS,
	payload: data,
})

export const deleteCaseRequestFailed = (data) => ({
	type: DELETE_CASE_REQUEST_FAILED,
	payload: data,
})

export const deleteCaseRequestClear = () => ({
	type: DELETE_CASE_REQUEST_CLEAR,
})

//Change Case Mode
export const changeCaseModeRequest = (data) => ({
	type: CHANGE_CASE_MODE_REQUEST,
	payload: data,
})

export const changeCaseModeRequestSuccess = (data) => ({
	type: CHANGE_CASE_MODE_REQUEST_SUCCESS,
	payload: data,
})

export const changeCaseModeRequestFailed = (data) => ({
	type: CHANGE_CASE_MODE_REQUEST_FAILED,
	payload: data,
})

export const changeCaseModeRequestClear = () => ({
	type: CHANGE_CASE_MODE_REQUEST_CLEAR,
})

export const getBifrostJobDetailsRequest = (data) => ({
	type: GET_BIFROST_JOB_DETAILS_REQUEST,
	payload: data,
})

export const getBifrostJobDetailsRequestSuccess = (data) => ({
	type: GET_BIFROST_JOB_DETAILS_REQUEST_SUCCESS,
	payload: data,
})

export const getBifrostJobDetailsRequestFailed = (data) => ({
	type: GET_BIFROST_JOB_DETAILS_REQUEST_FAILED,
	payload: data,
})

export const getBifrostJobDetailsRequestReset = () => ({
	type: GET_BIFROST_JOB_DETAILS_REQUEST_RESET,
})

export const postBifrostJobRequest = (data) => ({
	type: POST_BIFROST_JOB_REQUEST,
	payload: data,
})

export const postBifrostJobRequestSuccess = (data) => ({
	type: POST_BIFROST_JOB_REQUEST_SUCCESS,
	payload: data,
})

export const postBifrostJobRequestFailed = (data) => ({
	type: POST_BIFROST_JOB_REQUEST_FAILED,
	payload: data,
})

export const postBifrostJobRequestReset = () => ({
	type: POST_BIFROST_JOB_REQUEST_RESET,
})
